import React from "react";
import PowerBiEmbed from "../../components/powerBiEmbed";
import { ReportUrls } from "../../constants/reportUrls";
import {SFPageContainer } from "@sf-core";

const SkillCloud = () => (
  <SFPageContainer disableGutters>
    <PowerBiEmbed url={ReportUrls.SkillCloudDashboard} />
  </SFPageContainer>
);

export default SkillCloud;